var exports = {
  "r": "GitHubAvatar__m9j0NE",
};

module.exports = exports;
